import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.336 13.157 16 21.747l9.664-8.59-1.328-1.495L16 19.072l-8.336-7.41z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcChevronDown;
